import { MappedGolfCourseType } from './apis/golfCourses/types';

/**
 * Constants for hidden golf courses by section
 * These arrays contain the IDs of golf courses that should be hidden on the home page
 */
export const HIDDEN_FAVOURITE_AND_PROMOTED_GOLF_COURSES: number[] = [];
export const HIDDEN_SPAIN_GOLF_COURSES: number[] = [];
export const HIDDEN_PORTUGAL_GOLF_COURSES: number[] = [];
export const HIDDEN_ITALY_GOLF_COURSES: number[] = [];

export const isHiddenInFavouriteAndPromoted = (golfCourse: MappedGolfCourseType): boolean => {
  return HIDDEN_FAVOURITE_AND_PROMOTED_GOLF_COURSES.includes(golfCourse.golfCourse.id);
};

export const isHiddenInSpain = (golfCourse: MappedGolfCourseType): boolean => {
  return HIDDEN_SPAIN_GOLF_COURSES.includes(golfCourse.golfCourse.id);
};

export const isHiddenInPortugal = (golfCourse: MappedGolfCourseType): boolean => {
  return HIDDEN_PORTUGAL_GOLF_COURSES.includes(golfCourse.golfCourse.id);
};

export const isHiddenInItaly = (golfCourse: MappedGolfCourseType): boolean => {
  return HIDDEN_ITALY_GOLF_COURSES.includes(golfCourse.golfCourse.id);
};

export const filterHiddenGolfCourses = (
  golfCourses: MappedGolfCourseType[],
  isHiddenFn: (golfCourse: MappedGolfCourseType) => boolean
): MappedGolfCourseType[] => {
  return golfCourses.filter(golfCourse => !isHiddenFn(golfCourse));
};
